export default __webpack_public_path__ + "static/media/249.3c9065d4.jpg";